import { Id } from '#@/collections/typeId';

export class JobCancelData {
    id:Id=null
    reason?:string;

    constructor(initial?:Partial<JobCancelData>|null) {
        if (initial) Object.assign(this,initial);
    }
}